import * as $ from "jquery";
import {$body} from "../../Core/Body";
import DeleteAccountFormFields from "../Fields/DeleteAccountFormFields";

export default class DeleteAccountFormValidation{
    readonly Selector: any;

    constructor() {
        this.validate = this.validate.bind(this);
        this.Selector = {
            FORM: '#delete_user_form'
        }
    }


    public validate() {
        let rules = DeleteAccountFormFields.getFields(this.Selector);

        $(this.Selector.FORM).validate({
            rules: rules
        });
    }

    public onLoad() {
        if ($(this.Selector.FORM).length > 0) {
            $body.on("click", this.validate);
        }
    }

    public onChange() {
        if ($(this.Selector.FORM).length > 0) {
            $(window).on("change", this.validate);
        }
    }
}
import * as $ from "jquery";
import {$body} from "../../Core/Body";
import DeleteAccountFormFields from "../Fields/DeleteAccountFormFields";

export default class DeleteAccountFormValidation{
    readonly Selector: any;

    constructor() {
        this.validate = this.validate.bind(this);
        this.Selector = {
            FORM: '#delete_user_form'
        }
    }


    public validate() {
        let rules = DeleteAccountFormFields.getFields(this.Selector);

        $(this.Selector.FORM).validate({
            rules: rules
        });
    }

    public onLoad() {
        if ($(this.Selector.FORM).length > 0) {
            $body.on("click", this.validate);
        }
    }

    public onChange() {
        if ($(this.Selector.FORM).length > 0) {
            $(window).on("change", this.validate);
        }
    }
}
